import { Button, Card, Space } from 'antd';
import React from 'react';
import { useHistory } from 'react-router-dom';
import ResponsiveContainer from '../components/ResponsiveContainer';

function Core() {
  const history = useHistory();

  const adminVehiculos = async () => {
    history.push(`/core/admin-vehiculo`);
  };

  return (
    <ResponsiveContainer size="large">
      <Card title="Core" style={{ textAlign: 'left' }}>
        <Space direction="vertical">
          <Button type="link" onClick={adminVehiculos}>
            Administrar Vehículos
          </Button>
        </Space>
      </Card>
    </ResponsiveContainer>
  );
}

export default Core;
